import React from 'react';

import { Page } from '~/components/Page';
import { ResponseError } from '~/domain/ResponseError';

import { GenericErrorMessage } from './GenericErrorMessage';

interface IGenericErrorPage {
  error: Error | ResponseError;
}

export const GenericErrorPage: React.FC<IGenericErrorPage> = (props) => {
  const { error } = props;

  return (
    <Page>
      <GenericErrorMessage error={error} />
    </Page>
  );
};
